export default __webpack_public_path__ + "static/media/gallery_01.c46ee937.jpg";